import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var productSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    slug: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Slug *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден slug',
    }),
    bg_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Описание на български *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Описание на английски *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Цена *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна цена',
    }),
    status: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Статус',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валиден статус',
    }),
    option_type: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Option Type',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Option Type',
    }),
    brand: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'autocomplete',
        label: 'Бранд',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден Option Type',
    }),
    line_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Линия',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна линия',
    }),
    bg_subhead: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Подзаглавие(бг)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидно подзаглавие на български',
    }),
    en_subhead: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Подзаглавие(en)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидно подзаглавие на английски',
    }),
    bg_usage: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Употреба(бг)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидни инструкции за употреба на български',
    }),
    en_usage: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Употреба(en)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидни инструкции за употреба на английски',
    }),
    bg_pao: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Годност след отваряне(bg)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна годност след отваряне',
    }),
    en_pao: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Годност след отваряне(en)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна годност след отваряне',
    }),
    // composition: new FormItem({
    //     elementConfig: new ElementConfig({
    //         className: 'form-control',
    //     }),
    //     elementType: 'textarea',
    //     label: 'Състав',
    //     value: null,
    //     validation: {
    //         required: false,
    //     },
    //     valid: true,
    //     touched: false,
    //     errorMsg: 'Моля, въвдете валиден състав',
    // }),
    bg_manufacturer_information: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Информация за производител(bg)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидена информация',
    }),
    en_manufacturer_information: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Информация за производител(en)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидена информация',
    }),
    bg_features: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Отличителни характеристики(бг)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидни отличителни характористики на български',
    }),
    en_features: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Отличителни характеристики(en)',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидни отличителни характористики на английски',
    }),
    youtube_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'YouTube линк',
        value: null,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден линк към YouTube',
    }),
    categories: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: true,
        }),
        elementType: 'autocomplete',
        label: 'Категории',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    product_label: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Етикет',
        value: 'default',
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валиден етикет',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 1,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    promotion_percent_difference: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Процентни отсъпки',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидно число',
    }),
    brand_categories: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            multiple: true,
        }),
        elementType: 'autocomplete',
        label: 'Маркови категории',
        value: [],
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въвдете валидна категория',
    }),
    bg_seo_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на български',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на български',
    }),
    en_seo_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на английски',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете валидно име на английски',
    }),
    meta_title: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'input',
        label: 'Meta Заглавие',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно заглавие',
    }),
    meta_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'Meta Описание',
        value: '',
        validation: {
            required: false
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въведете валидно описание',
    }),
};
export default productSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/productSchema.ts
// module id = 406
// module chunks = 0